import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from '../../../../../../services/helpers.service';
import { RentalsService } from '../../../../../../services/rentals.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rental-override-store-times',
  templateUrl: './rental-override-store-times.component.html',
  styleUrls: ['./rental-override-store-times.component.scss'],
})
export class RentalOverrideStoreTimesComponent implements OnInit {
  @Input() configuration;
  public overrideTimes: any = [];
  public loadingOverrideTimes: boolean = false;
  public showOverrideStoreTime: boolean = false;
  public deleting: boolean = false;
  public panelData: any = {};
  public countryData: any = {};

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();
    this.getOverrideStoreTimes();
  }

  getOverrideStoreTimes() {
    this.loadingOverrideTimes = true;
    this.rentalsService
      .getOverrideStoreTimes(this.helpersService.getPartnerId())
      .subscribe(
        (res) => {
          this.overrideTimes = res;
          this.loadingOverrideTimes = false;
        },
        (err) => {
          this.loadingOverrideTimes = false;
        },
      );
  }

  canAddOverrideSlots() {
    return (
      this.configuration &&
      this.configuration.defaultStoreTimes &&
      this.configuration.defaultStoreTimes.filter((x: any) => {
        return x.isWorking;
      }).length > 0
    );
  }

  closePanel(data) {
    this.showOverrideStoreTime = false;
    this.overrideTimes = data;
  }

  addNew() {
    this.panelData = {
      defaultPartnerID: this.helpersService.getPartnerId(),
      isWorking: true,
    };
    this.showOverrideStoreTime = true;
  }

  editRecord(item) {
    this.panelData = JSON.parse(JSON.stringify(item));
    this.showOverrideStoreTime = true;
  }

  deleteRecord(item, index) {
    this.deleting = true;
    this.overrideTimes.splice(index, 1);
    this.rentalsService
      .deleteOverrideStoreTime(this.helpersService.getPartnerId(), item.id)
      .subscribe(
        (res) => {
          this.overrideTimes = res;
          this.deleting = false;
        },
        (err) => {
          this.deleting = false;
          this.getOverrideStoreTimes();
        },
      );
  }
}
